import { Box, styled, Typography } from "@mui/material";

import { Message } from "fond/widgets";

export const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

export const GridContainer = styled(Box)`
  height: clamp(200px, 50vh, 600px);

  .fullscreen & {
    flex: 1;
    min-height: 0;
    height: auto;
  }

  & > div {
    height: 100%;
  }

  & {
    .ag-row-level-0 {
      font-weight: "bold";
    }
    .ag-row-level-2 {
      color: ${({ theme }) => theme.palette.text.secondary};
      font-size: ${({ theme }) => theme.typography.size.xsmall};
    }
    .ag-row.ag-row-footer {
      background-color: ${({ theme }) => theme.palette.action.hover};
    }
  }
`;

export const Paragraph = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const NoBomMessage = styled(Message)(({ theme }) => ({
  margin: theme.spacing(2, 4),
}));

export const SumBar = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  padding: theme.spacing(1.5, 2),
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(4),
}));

export const SumBarTitle = styled(Typography)({
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
});

export const SumBarTotal = styled(Typography)(({ theme }) => ({
  whiteSpace: "nowrap",
  marginRight: theme.spacing(1),
}));
